<template>
    <popup :opened="opened" @close="close">
        <!-- BEGIN message to confirm activation of user account -->
        <div class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="text-pink-600 mb-10">Compte activé !</h3>
            <div class="text-center text-lg text-indigo-600 mb-10">
                <p>Votre compte a bien été activé.</p>
                <p>{{user.is_particulier ? "Vous pouvez dès à présent, utiliser Neopass." : "Vous pouvez dès à présent utiliser l'application Neopass."}}</p>
                <br />
                <p v-if="$trial()">La version d'essai est valable pour une durée de 15 jours.<br /> Elle vous permet d'accéder à tous les modules et de créer un carnet de parcours.</p>
            </div>
            <div class="w-full flex justify-center">
                <illustration name="basket" class="w-full" />
            </div>
        </div>
        <!-- END message to confirm activation of user account -->
    </popup>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';


export default {
  name:'PopupActivatedAccount',

  props:{
    opened: Boolean,
  },

  data() {
    return {
      //
    };
  },

  components:{
    Popup,
    Icon,
    Illustration,
  },

  methods:{
    close(){
      this.$emit('close');
    },
  },

  computed:{
    ...mapGetters({
      'user': 'auth/user',
    }),
  }
};
</script>
